import { render } from "./roleManager.vue?vue&type=template&id=e3110da4&scoped=true&ts=true"
import script from "./roleManager.vue?vue&type=script&lang=ts"
export * from "./roleManager.vue?vue&type=script&lang=ts"

import "./roleManager.vue?vue&type=style&index=0&id=e3110da4&lang=scss&scoped=true"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3110da4"]])

export default __exports__